import { ComponentProps } from "react";
import * as S from "./styles";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { Button } from "../../Atoms/Button";
import { useFormClientRegister } from "./useFormClientRegister";
import { ISelectOptions } from "../../../types/inputs";
import { IClienteForm } from "../../../types/cliente";
import { MessageErroForm } from "../../Atoms/MessageErroForm";

interface IFormClientRegisterProps extends ComponentProps<"form"> {
  submitForm: (data: IClienteForm) => void;
}

export const FormClientRegister = ({
  submitForm,
  ...rest
}: IFormClientRegisterProps) => {
  const {
    Controller,
    control,
    errors,
    handleSubmit,
    register,
    TipoOptions,
    watch,
    cidades,
    ufOptions,
    handleCep,
  } = useFormClientRegister();

  return (
    <S.MyFormClientRegister {...rest} onSubmit={handleSubmit(submitForm)}>
      <div>
        <Input
          data-error={!!errors?.nome}
          id="nome"
          {...register("nome")}
          label="Nome"
          required
        />
        {errors?.nome && (
          <MessageErroForm>{errors.nome.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          id="cpf"
          data-error={!!errors?.cpfCnpj}
          maxLength={14}
          {...register("cpfCnpj")}
          label="CPF"
          required
        />
        {errors?.cpfCnpj && (
          <MessageErroForm>{errors.cpfCnpj.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          data-error={!!errors?.email}
          id="email"
          {...register("email")}
          label="E-mail"
        />
        {errors?.email && (
          <MessageErroForm>{errors.email.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          id="telefone"
          {...register("telefone")}
          label="Telefone"
          required
          data-error={!!errors?.telefone}
          maxLength={15}
        />
        {errors?.telefone && (
          <MessageErroForm>{errors.telefone.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Controller
          control={control}
          name="tipo"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              inputId="tipo"
              label="Tipo"
              data-error={!!errors?.tipo}
              options={TipoOptions}
              onChange={(e: ISelectOptions) => onChange(e?.value)}
              value={TipoOptions.find((e) => e.value === value) || null}
            />
          )}
        />
        {errors?.tipo && (
          <MessageErroForm>{errors.tipo.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          id="cep"
          {...register("endereco.cep")}
          maxLength={9}
          label="CEP"
          onBlur={handleCep}
          required
        />

        {errors?.endereco?.cep && (
          <MessageErroForm>{errors.endereco.cep.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          id="rua"
          {...register("endereco.logradouro")}
          label="Endereço (Rua)"
          required
          data-error={!!errors?.endereco?.logradouro}
        />

        {errors?.endereco?.logradouro && (
          <MessageErroForm>
            {errors.endereco.logradouro.message}
          </MessageErroForm>
        )}
      </div>
      <div>
        <Input
          id="numer"
          {...register("endereco.numero")}
          label="Número"
          required
          data-error={!!errors?.endereco?.numero}
        />

        {errors?.endereco?.numero && (
          <MessageErroForm>{errors.endereco.numero.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          id="complemento"
          {...register("endereco.complemento")}
          label="Complemento"
          data-error={!!errors?.endereco?.complemento}
        />
        {errors?.endereco?.complemento && (
          <MessageErroForm>
            {errors.endereco.complemento.message}
          </MessageErroForm>
        )}
      </div>
      <div>
        <Input
          id="bairro"
          {...register("endereco.bairro")}
          label="Bairro"
          required
          data-error={!!errors?.endereco?.bairro}
        />

        {errors?.endereco?.bairro && (
          <MessageErroForm>{errors.endereco.bairro.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Controller
          control={control}
          name="endereco.uf"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              id="uf"
              label="UF"
              required
              data-error={!!errors?.endereco?.uf}
              value={ufOptions.find((i) => i.value === value) || null}
              options={ufOptions}
              onChange={(e: ISelectOptions) => onChange(e?.value)}
            />
          )}
        />

        {errors?.endereco?.uf && (
          <MessageErroForm>{errors.endereco.uf.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Controller
          control={control}
          name="endereco.cidade"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              key={watch("endereco.uf")}
              label="Cidade"
              required
              data-error={!!errors?.endereco?.cidade}
              options={cidades}
              value={cidades.find((e) => e.value === value) || null}
              onChange={(e: ISelectOptions) => onChange(e?.value)}
            />
          )}
        />
        {errors?.endereco?.cidade && (
          <MessageErroForm>{errors.endereco.cidade.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Button>Salvar</Button>
      </div>
    </S.MyFormClientRegister>
  );
};
